import { render, staticRenderFns } from "./CostsByCategory.vue?vue&type=template&id=a515bad0&scoped=true&"
import script from "./CostsByCategory.vue?vue&type=script&lang=js&"
export * from "./CostsByCategory.vue?vue&type=script&lang=js&"
import style0 from "./CostsByCategory.vue?vue&type=style&index=0&id=a515bad0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a515bad0",
  null
  
)

export default component.exports